import { createFileRoute, redirect } from '@tanstack/react-router';

import { administrationHomeFor } from '@/module/Travel/travelRoles';

import { useCurrentUserStore } from '@feature/security';

export const Route = createFileRoute('/_auth/administration/_administration/')({
  beforeLoad: ({ preload }) => {
    if (!preload) {
      throw redirect({
        to: administrationHomeFor(useCurrentUserStore.getState().currentUser?.currentRole),
        replace: true,
      });
    }
  },
});
